
    // @ts-nocheck
    import { __internal_buildRpcClient } from "@blitzjs/rpc";
    export default __internal_buildRpcClient({
      resolverName: "getLanguages",
      resolverType: "query",
      routePath: "/getLanguages",
      httpMethod: "POST",
    });
  